import Cards from "react-credit-cards";
import ProgressBar from "./ProgressBar";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import CardComponent from "../../Utilities/CardComponent";

const PaymentMethodForm = () => {
  const history = useHistory();
  const { addToast } = useToasts();
  const [focus, setFocus] = useState();
  const [show, setshow] = useState(false);
  const [expiry, setexpiry] = useState("");
  const [selected, setselected] = useState("");
  const [showcard, setshowcard] = useState("");
  const [datearray, setdatearray] = useState([]);
  const [montharray, setmontharray] = useState([]);
  const [montherror, setmontherror] = useState(false);
  const [existingcards, setexistingcards] = useState();
  const [stateCust, setstateCust] = useState(
    JSON.parse(sessionStorage.getItem("paymentMethod"))
  );
  const [expirationmonth, setexpirationmonth] = useState(
    stateCust?.expirationdatemonth
  );
  console.log("28", selected);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: JSON.parse(sessionStorage.getItem("paymentMethod")),
  });
  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */

    if (!JSON.parse(sessionStorage.getItem("movetopaymentpage"))) {
      history.push("/registration/customer-information");
      addToast(
        "Error! You cannot proceed furthur before filling previous details",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    } else {
      console.log("49", JSON.parse(sessionStorage.getItem("existingcards")));
      setshowcard(true);
      setexpiry(
        `${stateCust.expirationdatemonth}/${stateCust.expirationdateyear}`
      );
      setexistingcards(JSON.parse(sessionStorage.getItem("existingcards")));
      addyears();
    }
  }, []);
  const addyears = () => {
    let date2 = new Date();
    let arr = [date2.getFullYear()];
    for (let i = 1; i <= 16; i++) {
      let date = new Date();
      let adddata = date.getFullYear() + i;
      arr.push(adddata);
    }
    let month = Array.from(Array(12), (val, index) => index + 1);
    month.forEach((item) => {
      let appendedvalue = String(item).padStart(2, "0");
      setmontharray((prev) => [...prev, appendedvalue]);
    });
    setdatearray(arr);
  };

  const onyearChange = (e) => {
    setmontharray([]);
    if (Number(e.target.value) === Number(new Date().getFullYear())) {
      let monthnumber = new Date().getMonth();
      let month = Array.from(
        Array(12 - monthnumber),
        (val, index) => monthnumber + index + 1
      );
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
      if (Number(stateCust.expirationdatemonth) < Number(monthnumber + 1)) {
        stateCust.expirationdatemonth = "";
        setexpirationmonth("");
      }
    } else {
      let month = Array.from(Array(12), (val, index) => index + 1);
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
    }
  };
  const inputEvent = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setstateCust((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const checkifrequired = () => {
    if (!selected) return true;
    if (selected === "new_card") return true;
    return false;
  };
  const submitcustomerinformation = (data2) => {
    if (!expirationmonth && selected === "new_card") {
      setmontherror(true);
      return;
    }
    let obj = {};
    if (selected && selected !== "new_card") {
      let found = existingcards.findIndex((item) => item["token"] === selected);
      if (found !== -1) {
        obj = {
          cardHoldername: "",
          cardnumber: "",
          cvc: "",
          expirationdatemonth: "",
          expirationdateyear: "",
          token: existingcards[found]["token"],
          bin: existingcards[found]["bin"],
          last_4: existingcards[found]["last_4"],
        };
      }
    } else {
      obj = {
        cardHoldername: stateCust["cardHoldername"],
        cardnumber: stateCust["cardnumber"],
        cvc: stateCust["cvc"],
        expirationdatemonth: stateCust["expirationdatemonth"],
        expirationdateyear: stateCust["expirationdateyear"],
        token: "",
        bin: "",
        last_4: "",
      };
    }
    sessionStorage.setItem("paymentMethod", JSON.stringify(obj));
    sessionStorage.setItem("movetotermspage", true);
    if (existingcards && existingcards.length > 0) {
      setshow(true);
    } else {
      history.push("/registration/terms");
    }
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(submitcustomerinformation)}>
      <div>
        <ProgressBar typeofactive="Payment" />
        <div>
          {existingcards &&
            existingcards.length > 0 &&
            existingcards.map((item, index) => (
              <CardComponent
                cardDetails={item}
                key={index}
                selected={selected}
                setselected={setselected}
              />
            ))}
          {existingcards && existingcards.length > 0 && (
            <div className="my-3 d-flex align-items-center">
              <div className="existingcardor"></div>
              <h3 className="mb-0" style={{ flex: 0.04 }}>
                OR
              </h3>
              <div className="existingcardortwo"></div>
            </div>
          )}
          <div
            className={`${
              existingcards &&
              existingcards.length > 0 &&
              `newcardcomponent ${
                selected === "new_card" && "cardcomponentselected"
              }`
            }`}
          >
            {existingcards && existingcards.length > 0 && (
              <div className="d-flex mb-2">
                <input
                  type="radio"
                  id={"new_card"}
                  value={"new_card"}
                  checked={selected === "new_card"}
                  onChange={() => setselected("new_card")}
                />
              </div>
            )}
            {showcard && (
              <div className="form-group">
                <Cards
                  number={stateCust?.cardnumber}
                  name={stateCust?.cardHoldername}
                  expiry={expiry}
                  cvc={stateCust?.cvc}
                  focused={focus}
                />
              </div>
            )}
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <label style={{ display: "flex" }}>Card Holder Name</label>
                  <input
                    type="text"
                    {...register("cardHoldername", {
                      required: checkifrequired(),
                    })}
                    value={stateCust?.cardHoldername}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="Card Holder Name"
                    onFocus={(e) => setFocus(e.target.name)}
                  />
                  {errors.cardHoldername && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Card Holdername is required
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label style={{ display: "flex" }}>Credit Card</label>
              <div className="row">
                <div className="col-md-9">
                  <input
                    {...register("cardnumber", {
                      required: checkifrequired(),
                      maxLength: 20,
                      minLength: 15,
                    })}
                    type="number"
                    onWheel={(event) => event.currentTarget.blur()}
                    value={stateCust?.cardnumber}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="Card Number"
                    onFocus={(e) => setFocus(e.target.name)}
                  />
                  {errors.cardnumber?.type === "required" && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CardNumber is required
                    </span>
                  )}
                  {errors.cardnumber?.type === "minLength" && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CardNumber should be minimum of 15 numbers
                    </span>
                  )}
                  {errors.cardnumber?.type === "maxLength" && (
                    <span className="errormessage" style={{ fontSize: "15px" }}>
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CardNumber cannot exceed more than 20 numbers
                    </span>
                  )}
                </div>
                <div className="col-md-3">
                  <input
                    {...register("cvc", {
                      required: checkifrequired(),
                      minLength: 3,
                      maxLength: 4,
                    })}
                    type="number"
                    onWheel={(event) => event.currentTarget.blur()}
                    value={stateCust?.cvc}
                    onChange={inputEvent}
                    className="form-control"
                    onFocus={(e) => setFocus(e.target.name)}
                    placeholder="CVV"
                  />
                  {errors.cvc?.type === "required" && (
                    <span className="errormessage" style={{ fontSize: "14px" }}>
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CVV is required
                    </span>
                  )}
                  {errors.cvc?.type === "minLength" && (
                    <span className="errormessage" style={{ fontSize: "14px" }}>
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CVV should be minimum of 3 numbers
                    </span>
                  )}
                  {errors.cvc?.type === "maxLength" && (
                    <span className="errormessage" style={{ fontSize: "14px" }}>
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      CVV cannot be more than 4 numbers
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label style={{ display: "flex" }}>Expiration Date</label>
              <div className="row">
                <div className="col-md-6">
                  <select
                    {...register("expirationdatemonth", {
                      required: checkifrequired(),
                    })}
                    value={stateCust?.expirationdatemonth}
                    onChange={(e) => {
                      inputEvent(e);
                      setexpirationmonth(e.target.value);
                      if (e.target.value) {
                        setmontherror(false);
                      }
                      setexpiry(
                        `${e.target.value}/${stateCust?.expirationdateyear}`
                      );
                    }}
                    onFocus={(e) => setFocus(e.target.value)}
                    className="form-control"
                  >
                    <option value="">MM</option>
                    {montharray?.map((item, index) => (
                      <option key={index + 1} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  {errors.expirationdatemonth && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Month is required
                    </span>
                  )}
                  {montherror && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Month is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <select
                    {...register("expirationdateyear", {
                      required: checkifrequired(),
                    })}
                    value={stateCust?.expirationdateyear}
                    onChange={(e) => {
                      inputEvent(e);
                      onyearChange(e);
                      setexpiry(
                        `${stateCust?.expirationdatemonth}/${e.target.value}`
                      );
                    }}
                    className="form-control"
                  >
                    <option value="">YYYY</option>
                    {datearray?.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  {errors.expirationdateyear && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Year is required
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className="activation"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              className="btn "
              style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
              onClick={() => {
                sessionStorage.setItem("movetopaymentpage", false);
                history.push("/registration/activation-type");
              }}
            >
              Previous
            </button>
            <button className={"btn btn-primary"} type="submit">
              Next
            </button>
          </div>
        </div>
      </div>
      <Modal backdrop="static" show={show}>
        <Modal.Header>
          <Modal.Title>Confirmation!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to continue with your{" "}
          {!selected || selected === "new_card" ? (
            <strong>New Card</strong>
          ) : (
            <strong>Existing Card</strong>
          )}
          ?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-success"
            onClick={() => history.push("/registration/terms")}
          >
            Yes
          </button>
          <button
            className="btn btn-danger ml-2"
            onClick={() => setshow(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default PaymentMethodForm;
